export function calculateEndDate(start: string, months: number): string {
	if (typeof start !== "string" || !/^\d{4}-\d{2}-\d{2}$/.test(start)) {
		throw new Error('Parameter "start" must be a string in YYYY-MM-DD format.');
	}

	if (typeof months !== "number" || !Number.isFinite(months)) {
		throw new Error('Parameter "months" must be a valid number.');
	}

	const [yearStr, monthStr, dayStr] = start.split("-");
	let year = Number(yearStr);
	let month = Number(monthStr);
	let day = Number(dayStr);

	// ➕ Add months manually
	month += months;

	// Normalize overflow
	while (month > 12) {
		month -= 12;
		year++;
	}
	while (month < 1) {
		month += 12;
		year--;
	}

	// Get last valid day of the target month
	const lastDay = new Date(year, month, 0).getDate();
	day = Math.min(day, lastDay);

	const yyyy = String(year);
	const mm = String(month).padStart(2, "0");
	const dd = String(day).padStart(2, "0");

	return `${yyyy}-${mm}-${dd}`;
}
